import React from "react";
import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import { Card } from "react-bootstrap";
import bladesLogo from "../../../../../src/assets/blades-in-the-dark/logo-blades-in-the-dark.png";
import sectionDivider from "../../../../../src/assets/blades-in-the-dark/banner-bitd.webp";
import "../../../../index.css";
import { ContentContainer } from "../../SessionSection";
import { useEffect } from "react";
import NavDistricts from "./NavDistricts";
import NavCampaign from "./NavCampaign";

const pageHeader = {
  color: "white",
  backgroundColor: "black",
  opacity: "0.7",
  marginTop: "20px",
  padding: "15px",
};
const cardStyle = {
  textAlign: "left",
  fontFamily: "Special Elite",
  backgroundColor: "rgba(0, 0, 0, .7) ",
  color: "white",
  marginBottom: "15px",
};

const section1Data = [
  {
    title: "",
    text: (
      <div className="morkBorgFont morkBorgTitleText">
        <p align="center">
          <NavDistricts />

          <img
            src="https://www.smokeraven.com/static/html/assets/blades-in-the-dark/places/district-header-text-six-towers.webp"
            alt="Six Towers"
          />
        </p>
        <strong>
          A formerly rich district, now worn down and dilapidated.
        </strong>{" "}
        <em>
          This formerly prestigious district has faded over the centuries into a
          pale shadow of what it once was. The eponymous six towers were
          originally the grand residences of Doskvol’s first noble families. All
          but two (Bowmore House and Rowan House) have been sold off and
          converted into cheap apartments or fallen into ruin and abandoned. The
          district has an empty, haunted feel, with many sprawling old buildings
          dark without power, broad stone streets cracked and buckled, and the
          fires of squatters crackling from overgrown lots.
        </em>
        <img
          src="https://www.smokeraven.com/static/html/assets/blades-in-the-dark/places/district-header-six-towers.webp"
          alt="Six Towers"
        />
        <table className="district-table">
          <thead>
            <tr>
              <th>Description</th>
              <th>District Details</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td valign="top">
                <strong>Scene:</strong> Bits of trash, blown by a cold wind,
                skitter across empty streets, illuminated only by a few
                still-working street lamps and the campfires of squatters. The
                shutters and doors of abandoned buildings moan, creak, and bang
                in a haunted chorus. Residents hustle by, heads down, clutching
                spiritbane charms close to their breasts.
                <br />
                <strong>Streets:</strong> Broad stone avenues, cracked and
                broken, dark without power; overgrown and neglected.
                <br />
                <em>Comber Way, Bowmore Way, Rowan Way, Coleburn Avenue.</em>
                <br />
                <strong>Buildings:</strong> Palatial estates, tumbled into
                disrepair. Grand manors, remodeled into cramped and cheap
                apartments.
                <br />
                <strong>Factions:</strong>
                <ul>
                  <li>1. Lord Scurlock</li>
                  <li>2. The Circle of Flame</li>
                  <li>3. The Unseen</li>
                  <li>4. Dimmer Sisters</li>
                  <li>5. The Grey Cloaks</li>
                </ul>
              </td>
              <td valign="top">
                <img
                  src="https://www.smokeraven.com/static/html/assets/blades-in-the-dark/places/district-traits-six-towers.webp"
                  alt="Six Towers district traits"
                />
                <br />
                <br />
                <em>
                  The many empty buildings and abandoned properties make this
                  district a perfect location for a hidden scoundrel’s lair.
                </em>
              </td>
            </tr>
          </tbody>
        </table>
        <br />
        <h1>Six Towers Locations</h1>
        <strong>
          <u>Arms of the Weeping Lady</u>
        </strong>
        : This grand building, formerly an opera house, is now a soup-kitchen
        and bunkhouse for the destitute, run by the charity of the Weeping Lady.
        Locals use this landmark as the demarcation between the districts of
        Charterhall and Six Towers.
        <br />
        <br />
        <strong>
          <u>Mistshore Park</u>
        </strong>
        : This dark and overgrown space overlooks the eastern branch of the
        river Dosk and the deathlands beyond. In old folk ballads, young lovers
        who could not be together would commit suicide in this park. Whatever
        the truth of it, the park is certainly haunted now.
        <br />
        <br />
        <strong>
          <u>Rowan House</u>
        </strong>
        : One of the last of the original six towers, this antique building
        resembles an ancient castle from history books, complete with moat,
        draw-bridge, and arrow-slit windows. The powerful Rowan family rules
        their holdings from within the fortress, rarely venturing beyond the
        security of its thick stone walls.
        <br />
        <br />
        <strong>
          <u>Scurlock Manor</u>
        </strong>
        : The Scurlock family came to Duskwall centuries ago and was once a
        great force in the city, before some curse or calamity befell their
        line. This tumble-down manor house and tangle of vines is all that
        remains of their original fortune. It’s said that a young nephew or
        cousin still resides there, but Lord Scurlock himself has moved on to
        finer abodes.
        <p>
          <a href="#pageTop">Back to Top</a>
        </p>
      </div>
    ),
  },
];

const BITDClasses_Districts_SixTowers = () => {
  useEffect(() => {
    document.body.style.backgroundImage = `url(${require("../../../../../src/assets/blades-in-the-dark/mood-doskvol_street-scene-01.webp")})`;
    document.body.style.backgroundColor = "#000000";
    document.body.style.back = "fixed";
    document.body.style.backgroundRepeat = "no-repeat";
    document.body.style.backgroundAttachment = "fixed";
  }, []);

  return (
    <div>
      <Container>
        <Row>
          <Col>
            <div
              style={{
                backgroundColor: "transparent",
                fontFamily: "Orbitron",
              }}
            >
              <main role="main" className="inner cover text-center">
                <img
                  src={bladesLogo}
                  style={{ maxWidth: "200px" }}
                  alt="Blades in the Dark campaign"
                />
              </main>
              <div style={pageHeader}>
                <h1 className="cover-heading">Blades in the Dark: Campaign</h1>
                <p className="lead leadExtra">
                  <NavCampaign />
                </p>
              </div>
            </div>
          </Col>
        </Row>
        <Row>
          <Col>
            <Card style={cardStyle}>
              <a name="pageTop" href="#pageTop">
                {" "}
              </a>
              <img
                src={sectionDivider}
                className="BITD-section-divider"
                alt="section divider"
              />
              <Card.Body>
                <Card.Text>
                  <ContentContainer data={section1Data} />
                </Card.Text>
              </Card.Body>
            </Card>
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default BITDClasses_Districts_SixTowers;
